import { useMemo } from 'react'

import { ActiveState, Icon, type NavGroup } from '@graftcode/design-system'

import { LAYOUT_TEST_IDS } from '@common/common-test-ids.const'
import { AppVariant } from '@common/enums'

import type { LayoutGateway } from '../layout.interface'
import { getGatewayTargetUrl } from '../utils/getGatewayTargetUrl'
import { mapGatewayStatusToVariant } from '../utils/mapGatewayStatusToVariant'

interface UseVisionGatewayMenuItemsParams {
  gateways: LayoutGateway[]
  isVisionRoute: boolean
  noGatewaysLabel: string
  selectedNavId: AppVariant
}

export function useVisionGatewayMenuItems({
  gateways,
  isVisionRoute,
  noGatewaysLabel,
  selectedNavId,
}: UseVisionGatewayMenuItemsParams) {
  return useMemo<NavGroup[] | undefined>(() => {
    if (selectedNavId !== AppVariant.VISION || !isVisionRoute) return undefined

    if (gateways.length === 0) {
      return [{ items: [{ label: noGatewaysLabel, url: 'vision', icon: Icon.CircleRegular, disabled: true }] }]
    }

    return [
      {
        items: gateways.map((gateway) => ({
          id: gateway.gatewayId,
          label: gateway.name || gateway.gatewayKey || gateway.gatewayId,
          url: getGatewayTargetUrl(gateway),
          icon: Icon.CircleRegular,
          slotRight: (
            <ActiveState
              variant={mapGatewayStatusToVariant(gateway.status)}
              size="small"
              showLabel={false}
              data-testid={LAYOUT_TEST_IDS.gatewayStatus}
            />
          ),
        })),
      },
    ]
  }, [gateways, isVisionRoute, noGatewaysLabel, selectedNavId])
}
